module.exports = "/video-roulette/img/btn-background-black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/btn-background-black.png
// module id = 2432
// module chunks = 10